import { Thumbnail } from './Thumbnail';

const name = 'Thumbnail';

export { name, Thumbnail };
